import React from 'react'

import { PerfectInfo } from '@/containers/Account/PerfectInfo'

const PerfectUserInfo: React.FC = () => {
    return <PerfectInfo />
}

export default PerfectUserInfo
